import {
  AgentPlayerBalanceSummaryResponse,
  BalanceSummaryResponse,
  BonusAnalyticsResponse,
  BusinessAnalyticsResponse,
  CasinoAnalyticsResponse,
  DateFilter,
  DeviceBreakdownResponse,
  GameAnalyticsQuery,
  GameAnalyticsResponse,
  LiveGamesResponse,
  LoginSummaryResponse,
  TopCategoriesResponse,
  TopUsersQueryParams,
  TopUsersResponse,
  UserManagementResponse,
} from '@/types/dashboard';
import apiSlice from './apiSlice';

export const dashboardApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getBalanceSummary: builder.query<BalanceSummaryResponse, DateFilter | void>({
      query: (params) => ({
        url: '/dashboard/balance-summary',
        method: 'GET',
        params,
      }),
      providesTags: ['BalanceSummary'],
    }),
    getAgentPlayerBalanceSummary: builder.query<
      AgentPlayerBalanceSummaryResponse,
      DateFilter | void
    >({
      query: (params) => ({
        url: '/dashboard/agent-player-balances',
        method: 'GET',
        params,
      }),
      providesTags: ['BalanceSummary'],
    }),

    getUserManagement: builder.query<UserManagementResponse, DateFilter | void>({
      query: (params) => ({
        url: '/dashboard/user-management',
        method: 'GET',
        params,
      }),
      providesTags: ['UserManagement'],
    }),

    getGameAnalytics: builder.query<GameAnalyticsResponse, GameAnalyticsQuery | void>({
      query: (params) => ({
        url: '/dashboard/game-analytics',
        method: 'GET',
        params,
      }),
      providesTags: ['GameAnalytics'],
    }),

    getCasinoAnalytics: builder.query<CasinoAnalyticsResponse, DateFilter | void>({
      query: (params) => ({
        url: '/dashboard/casino-analytics',
        method: 'GET',
        params,
      }),
      providesTags: ['CasinoAnalytics'],
    }),

    getBusinessAnalytics: builder.query<BusinessAnalyticsResponse, DateFilter | void>({
      query: (params) => ({
        url: '/dashboard/business-analytics',
        method: 'GET',
        params,
      }),
      providesTags: ['BusinessAnalytics'],
    }),

    getTopUsers: builder.query<TopUsersResponse, TopUsersQueryParams>({
      query: (params) => ({
        url: '/dashboard/top-users',
        method: 'GET',
        params,
      }),
      providesTags: ['TopUsers'],
    }),

    getTopCategories: builder.query<TopCategoriesResponse, DateFilter | void>({
      query: (params) => ({
        url: '/dashboard/top-categories',
        method: 'GET',
        params,
      }),
      providesTags: ['TopCategories'],
    }),

    getDeviceBreakdown: builder.query<DeviceBreakdownResponse, DateFilter | void>({
      query: (params) => ({
        url: '/dashboard/device-breakdown',
        method: 'GET',
        params,
      }),
      providesTags: ['DeviceBreakdown'],
    }),

    getBonusAnalytics: builder.query<BonusAnalyticsResponse, DateFilter | void>({
      query: (params) => ({
        url: '/dashboard/bonus-analytics',
        method: 'GET',
        params,
      }),
      providesTags: ['BonusAnalytics'],
    }),

    getLoginSummary: builder.query<LoginSummaryResponse, DateFilter | void>({
      query: (params) => ({
        url: '/dashboard/login-summary',
        method: 'GET',
        params,
      }),
      providesTags: ['LoginSummary'],
    }),

    getLiveGames: builder.query<LiveGamesResponse, { sport: string }>({
      query: ({ sport }) => ({
        url: `/dashboard/live-games${sport ? `?sport=${sport}` : ''}`,
        method: 'GET',
      }),
      providesTags: ['LiveGames'],
    }),
  }),
});

export const {
  useGetBalanceSummaryQuery,
  useGetAgentPlayerBalanceSummaryQuery,
  useGetUserManagementQuery,
  useGetGameAnalyticsQuery,
  useGetCasinoAnalyticsQuery,
  useGetBusinessAnalyticsQuery,
  useGetTopUsersQuery,
  useGetTopCategoriesQuery,
  useGetDeviceBreakdownQuery,
  useGetBonusAnalyticsQuery,
  useGetLoginSummaryQuery,
  useGetLiveGamesQuery,
} = dashboardApi;
